'use client';
import { Card, CardContent } from '@eliadmin/core/src/components/ui/card';
import { Carousel } from '@eliadmin/core/src/components/ui/carousel';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { useRouter } from 'next/navigation';
export type IconsWithTextProps = {
  className?: {
    root?: string;
    card?: string;
    cardContent?: string;
    iconContainer?: string;
    infoContainer?: string;
    title?: string;
    description?: string;
  };
  data: {
    key: string;
    title: string;
    description?: string;
    icon: React.ReactNode;
    slug?: string;
  }[];
};
export type IconsWithTextItem = IconsWithTextProps['data'][number];

export function IconsWithText(props: IconsWithTextProps) {
  const router = useRouter();

  const slides = props.data.map(item => {
    return (
      <Card
        key={item.key}
        className={cn('w-full shadow-none', 'ea-icons-with-text__card', props.className?.card)}
      >
        <CardContent
          className={cn(
            'flex flex-col items-center justify-start gap-4 p-4 text-center',
            'ea-icons-with-text__card-content',
            item.slug && 'cursor-pointer',
            props.className?.cardContent,
          )}
          onClick={() => {
            item.slug && router.push(item.slug);
          }}
        >
          <div
            className={cn(
              'flex-shrink-0 flex-grow-0 rounded-md text-primary',
              'ea-icons-with-text__icon-container',
              props.className?.iconContainer,
            )}
          >
            {item.icon}
          </div>
          <div
            className={cn(
              'flex-shrink-0 flex-grow-0',
              'ea-icons-with-text__info-container',
              props.className?.infoContainer,
            )}
          >
            <h2
              data-ea-visual-tag="h3"
              className={cn(
                'text-lg font-bold',
                'ea-icons-with-text__title',
                props.className?.title,
              )}
            >
              {item.title}
            </h2>
            <p
              className={cn(
                'text-sm text-muted-foreground',
                'ea-icons-with-text__description',
                props.className?.description,
              )}
            >
              {item.description}
            </p>
          </div>
        </CardContent>
      </Card>
    );
  });

  return (
    <Carousel
      slides={slides}
      className={{
        wrapper: 'h-max w-full',
        container: 'w-full gap-3',
        main: 'w-full',
        slide: 'max-w-[240px] w-full bg-primary/10 rounded-lg',
      }}
      options={{
        align: 'start',
      }}
    />
  );
}
